import { Component, type ErrorInfo, type ReactNode } from "react";

import { takeStalePageRetrySlot } from "./stalePageReload";

type ErrorBoundaryState = { failed: boolean; refreshingStaleBundle: boolean };

export class ErrorBoundary extends Component<{ children: ReactNode }, ErrorBoundaryState> {
  state: ErrorBoundaryState = { failed: false, refreshingStaleBundle: false };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { failed: true, refreshingStaleBundle: isStalePageBundleError(error) };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Precise Plate UI error", { message: error.message, componentStack: info.componentStack });
    if (isStalePageBundleError(error)) {
      if (takeStalePageRetrySlot()) {
        window.setTimeout(() => window.location.reload(), 0);
      } else {
        this.setState({ failed: true, refreshingStaleBundle: false });
      }
    }
  }

  render() {
    if (!this.state.failed) return this.props.children;
    if (this.state.refreshingStaleBundle) {
      return <main className="boot-shell"><section className="boot-panel centered-state"><h1>Refreshing Precise Plate</h1><p>The app is opening the latest version of this page.</p></section></main>;
    }
    return <main className="boot-shell"><section className="boot-panel centered-state"><h1>Precise Plate ran into a problem</h1><p>Your saved account data was not removed. Reload the app, or contact support if the problem continues.</p><div className="account-actions"><button className="button primary" onClick={() => window.location.reload()}>Reload app</button><a className="button secondary" href="/support">Contact support</a></div></section></main>;
  }
}

function isStalePageBundleError(error: Error): boolean {
  return [
    "failed to fetch dynamically imported module",
    "error loading dynamically imported module",
    "importing a module script failed",
    "load failed",
  ].some((message) => error.message.toLowerCase().includes(message));
}
